{#each topLinkGroups as group}
  <FooterTopLinkGroup {colorClassNames} {...group} />
{/each}

<script>
  import FooterTopLinkGroup from './FooterTopLinkGroup.html';

  export let topLinkGroups;
  export let colorClassNames;
</script>
